import { createSelector } from '@ngrx/store';
import { deviceIdFilter } from 'src/app/utils/functions/store.functions';
import { ILicensesState, IRemoteXPACPortalState } from '../../utils/interfaces/store.interfaces';

export const selectLicenses = (state: IRemoteXPACPortalState) => state.licenses;

export const selectSubscriptionDetails = (deviceId: string) => createSelector(
  selectLicenses,
  (state: ILicensesState) => deviceIdFilter(deviceId, state.subscriptionDetails)
);

export const selectActiveStoreLicensesInfo = createSelector(
  selectLicenses,
  (state: ILicensesState) => state.activeStoreLicensesInfo
);

export const selectExpiringStoreLicensesInfo = createSelector(
  selectLicenses,
  (state: ILicensesState) => state.expiringStoreLicensesInfo
);

export const selectExpiredStoreLicensesInfo = createSelector(
  selectLicenses,
  (state: ILicensesState) => state.expiredStoreLicensesInfo
);

export const selectShoppingBasket = createSelector(
  selectLicenses,
  (state: ILicensesState) => state.shoppingBasket
);

export const selectLicenseOrders = createSelector(
  selectLicenses,
  (state: ILicensesState) => state.orders
);

export const selectOrder = (orderId: string) => createSelector(
  selectLicenses,
  (state: ILicensesState) => state.annotatedOrder?.id === orderId ? state.annotatedOrder : null
);

export const selectManualSubscription = (deviceId: string) => createSelector(
  selectLicenses,
  (state: ILicensesState) => deviceIdFilter(deviceId, state.manualSubscription)
);

export const selectLicensesPermissions = createSelector(
  selectLicenses,
  (state: ILicensesState) => state.permission
);

export const selectInsightsOffers = createSelector(
  selectLicenses,
  (state: ILicensesState) => state.insightsOffers,
);